export default {
    eventParentUnavailable: {
        title: 'Original parent lead unavailable',
        description:
            'This Event Module lead cannot be opened because its original parent lead is unavailable. Restore the original parent before restoring this event lead, or contact your administrator to have the relationship checked.',
    },
    alreadyAssociatedWithCustomer: 'Already associated with this customer',
    account: 'Account',
    action: 'Action',
    activateConfirmationApptService:
        'Enabling this option will result in sending your service appointment confirmation in double since it is also sent by your DMS. @:general.wishToProceed',
    additionalNotes: 'Additional notes',
    addComment: 'Add a note',
    addCommentOrUpload: 'Add a note or drop a file here',
    addCommentMentions: 'Mention',
    addCommentMentionsDisabled: 'You cannot mention while it is a private note',
    addCommunication: 'Add a communication',
    addLead: 'Add new lead',
    addLeadsToSalesJourney: 'Add leads to this sales journey',
    addLeadsToSalesJourneyFailure: {
        invalid: 'Lead ID {0} is invalid for attribution.<br>{1} leads have been added',
        unable: 'Lead ID {0} could not be added to sales journey.<br>{1} leads have been added',
        unknown: 'An error occurred while adding leads to sales journey',
    },
    addLeadsToThisSalesJourneyModalTitle: 'Add leads to this current sales journey',
    addLeadsToThisSalesJourneySuccess: 'All leads successfully added to sales journey',
    salesJourneyTable: {
        clients: 'Clients',
        date: 'Date',
        performance: 'Performance',
    },
    addNewLead:
        'You cannot add a trade-in vehicle for @:lexicon.portfolio.prefix, please add a new @:lexicon.portfolio.singular lead instead.',
    addOriginalEmail: 'Original email',
    addPrecision: 'Please specify',
    address: 'Address',
    addLeadsToJourney: 'Add {leadCount} lead to journey|Add {leadCount} leads to journey',
    addLeadToJourneyMaxLeadsSelected:
        'A limit of {maxLeadCount} leads can be added at the same time',
    addToJourney: 'Add to journey',
    addToSalesJourney: 'Add to a sales journey',
    addVehicle: 'Add a vehicle',
    addVisitWithoutAppointmentWarning:
        'It is strongly recommended that you book an appointment to avoid altering the statistics between the number of visits and the number of appointments.{br}{br}Are you sure you want to continue?',
    advisor: 'Associate',
    alertInvalidStatus:
        'You cannot invalidate the lead because an Appt. / Visit / @.capitalize:lexicon.sale.singular / @.capitalize:lexicon.delivery.singular is planned',
    noAccessToSelectOption: 'You do not have access to select this option',
    alertSent: 'Alert sent',
    all: 'All',
    alreadyExported: 'Already exported',
    answered: 'Answered',
    appointment: 'Appointment',
    approved: 'Client Approval',
    apply: 'Apply',
    assignationDontAllow: "You can't assign yourself. Please make an assign request.",
    assignationRequest: 'Assignment request',
    assignationsAndDates: 'Assignments & Dates',
    assignedRequestAdvisor: '{user} made an assignment request. It is pending approval',
    assignedRequestNeedToBeApprovedAdvisor:
        "{user} made an assignment request. Approve / reject it by clicking on the associate's name",
    assignedRequestNeedToBeApprovedBdc:
        "{user} made an assignment request. Approve / reject it by clicking on the agent's name",
    associate: 'Associate',
    associateLead: 'Associate',
    associatingLead: 'Associating the lead',
    association: 'Association',
    attachFiles: 'Attach files',
    attachFilesCount: '{count} file selected | {count} files selected',
    attachments: 'Attachments',
    attemped: 'Attemped',
    attempted: 'Attempted',
    needsAttention: 'Needs attention',
    attributed: 'Attributed',
    audio: 'Audio',
    autoCalculatedField: 'Automatically calculated field',
    automatedEmail: 'Automated email',
    automatedSms: 'Automated Sms',
    availableDate: 'Veh. here on',
    basicInfo: 'Basic information',
    bdc: 'BDC Agent',
    bdcAgent: 'BDC Agent',
    beBack: 'B-back',
    bestMatch: 'Best match',
    birthDate: 'Date of birth',
    blockedPhoneModification:
        'This phone is linked to a NioText conversation and cannot be deleted. Do you want to modify this phone?',
    blockedPhoneModificationSms:
        'This phone is linked to an SMS conversation and cannot be deleted. Do you want to modify this phone?',
    business: 'Business',
    businessTooltip: 'Business Client',
    call: 'Call',
    callDate: 'Call date',
    callDescription: 'Call description',
    cannotAddVehicleRenewal: 'Impossible action',
    cantAddAudioNoteWithText: "You can't add audio on a note containing text",
    cantAssociateEventLead: "You can't dissociate an event lead",
    cantAssociateLeadWithEventRelated: "You can't dissociate a lead related to an event lead",
    cantSelectActualLead: "Can't select current lead",
    cantChangeDivisionLeadType:
        'To modify the division, you first need to change the "{0}" lead type because it is only valid for the "{1}" division.',
    cantChangeDivisionSoldProducts:
        'You cannot change the "{0}" division when products have already been @:lexicon.sold.singular .',
    cantUncheckOnWalkIn: 'The visit cannot be unchecked on @:lexicon.walkIn.prefix',
    carIsAlreadySold: 'This lead already has a @:lexicon.sale.singular',
    cases: 'Cases',
    certified: 'Certified',
    certifiedTooltip: 'Certified Used Vehicle',
    changeValueCBB:
        'This value was defined by Canadian Black Book, are you sure you wish to modify it?',
    changeValueCBBTitle: 'Value defined by Canadian Black Book',
    chooseAssociationRule: 'Please choose the association rule',
    chooseDeliveredVehicle: 'Please select the @:lexicon.delivered.singular vehicle',
    chooseDeliveryMan: 'Choose a @:lexicon.delivery.singular specialist',
    chooseDirector: 'Choose a manager',
    chooseFusionRule: 'Please choose the merge rule',
    chooseRecordedVehicle: 'Please select the reported vehicle',
    chooseRefinancedVehicle: 'Please select the refinanced vehicle',
    chooseRenewalVehicle: 'Please select the @:lexicon.renewed.singular vehicle',
    chooseServiceVehicle: 'Please select the vehicle for the servicing',
    chooseSoldVehicle: 'Please select the @:lexicon.sold.singular vehicle',
    chooseVehicleToExport: 'Please select the vehicle to export',
    chooseCdkDriveExportOptions: 'Please select CDK Drive deal export options',
    chooseSupplierExportOptions: 'Please select {0} export options',
    city: 'City',
    civility: '@.capitalize:lexicon.civility.singular',
    clickOpenNewTab: 'Open link in new tab',
    client: 'Client',
    clientEmail: 'CLIENT EMAIL',
    clientIsAllUnsubscribed: "The client doesn't want to be contacted until {0}",
    clientIsAllUnsubscribedForever: "The client doesn't want to be contacted",
    clientIsCallUnsubscribed: 'The client unsubscribed from call',
    clientIsEmailUnsubscribed: 'The client unsubscribed from email',
    clientIsSmsUnsubscribed: 'The client unsubscribed from SMS',
    clientNumber: 'Client #',
    clientType: 'Client type',
    close: 'Close',
    code: 'Code',
    comment: 'Notes',
    commercial: 'F&I',
    commercialShort: 'F&I',
    communicationCreatedByCrmDisabledTooltip:
        'These fields cannot be changed on a CRM communication',
    communicationMethod: 'Method',
    communicationPreference: 'Preference',
    communicationPreferenceTooltip: 'Communication preference',
    communications: 'Communications with the client',
    communicationType: 'Communication type',
    contactType: {
        home: 'Home Contact',
        work: 'Work Contact',
    },
    crmCreatedAt: 'Added to CRM on {date}',
    businessName: 'Business name',
    casl: 'Communication consent',
    complete: 'Complete',
    completingLead: 'Completing the lead',
    contact: 'Contact',
    contactDms: 'Contact :',
    contractEndDate: 'Contract end date',
    correspondingLeads: 'List of corresponding leads',
    country: 'Country',
    createdAt: 'Created',
    createdBy: 'Created by',
    createLead: 'Create a new lead',
    creatingLead: 'Creating the lead',
    csi: 'CSI',
    csiCompleted: 'CSI completed',
    customerEmail: 'Customer Email',
    customerIntelligenceSummary: 'Customer Intelligence Summary',
    date: 'Date',
    dateTime: 'Date & time',
    dealerTour: 'Dealer Tour',
    delete: 'Delete',
    deleteCommunicationConfirm: 'This communication will be deleted permanently',
    deletedAt: 'Deleted At',
    deletedBy: 'Deleted By',
    deleteLead: 'Delete lead',
    deleteVehicle: 'Delete this vehicle',
    deleteVehicleConfirm: 'Are you sure that you want to delete this vehicle?',
    deleteVehicleSubConfirm: 'You will not able to retrieve it!',
    deliverableDate: 'Veh. @:lexicon.deliverable.singular on',
    delivered: '@.capitalize:lexicon.delivered.singular',
    deliveredBy: '@.capitalize:lexicon.delivered.singular by',
    deliveryDate: '@.capitalize:lexicon.deliveryDate.singular',
    deliveryPrepDate: 'Veh. here on',
    deposit: 'Deposit',
    details: 'Details',
    vehicleNoStockNumberOrVinText:
        'Only vehicles with a VIN or stock # will be exported. Do you want to continue?',
    vehicleNoStockNumberOrVinTitle: 'VIN or stock # required',
    discounted: 'Funded | Funded',
    discountedMustBeActive:
        'The Funded option must be active in the account to have access to this option',
    dissociateCurrentLeadOnly: 'Dissociate current lead only',
    division: 'Division',
    dmsError: 'An error on the side of {0} occurred. Please try again later.',
    exportFailed: 'Export failed',
    integrationSuspended:
        'Export to {0} not currently available.<br>Please contact Activix Support for more information.',
    integrationExportNoAdvisorsSuppliers: 'This lead has no assigned advisors configured with {0}.',
    dmsErrorLead: '{0} experienced an error.<br>The lead {1} was not exported.',
    dmsErrorUserNotFound: 'User does not exist in {0}.<br>The lead {1} was not exported.',
    dmsErrorLeadLocked:
        '{0} experienced an error.<br>The lead {1} was not exported.<br>The deal in {0} is currently in use.',
    dmsErrorLeadStock:
        '{0} experienced an error.<br>The lead {1} was not exported.<br>Stock number already exists for another VIN.',
    dnd: 'DND.',
    doNotDisturb: 'Do not disturb',
    dndTitle: 'DND date',
    dndTooltip: "Date until the client doesn't want to be disturbed",
    doNotMarket: 'Do not market',
    dollarAndLost: 'Dollar & Lost',
    download: 'Download',
    dropAttachment: 'Drop file here',
    duplicate: 'Duplicate',
    duplicateLead: 'Lead already exported.',
    durationTooltip: 'Response time{br}(from CRM)',
    edit: 'Edit',
    editing: 'Editing',
    editCommunication: 'Edit a communication',
    edited: 'Edited',
    email: 'Email',
    emailType: {
        home: 'Home email',
        work: 'Work email',
    },
    emailReadAt: 'Email read at',
    endContractDate: 'End contract date',
    endContractDateExchange: 'End contract date (E)',
    endContractRequired:
        'The end contract date in the trade-in vehicle is required to select the @:lexicon.portfolio.singular type',
    endServiceDate: 'End of service',
    exchanges: 'Exchanges',
    exchangeVehicle: 'Trade-in Vehicle',
    excluded: 'Excluded',
    exportedVehicleDisable: 'You cannot delete a vehicle that has been exported to {0}',
    exporting: 'Export in progress...',
    exportCompleted: 'Evaluation completed',
    exportTo: 'Export to',
    exportWaiting: 'Waiting',
    generatePdfTooltip: 'The ‘Primary Vehicle’ from the Lead will be used in PDF generation',
    goTo: 'Go to',
    exportToAutoVanceRequired: 'You must first export to Autovance',
    exportToDeskitRequired: 'You must first export to Deskit',
    fieldFromGroup: 'Field from the {0} group',
    files: 'Files',
    firstName: 'First name',
    firstUpdateTimeTooltip: 'First update time',
    followUp: 'FollowUp',
    freezedFinancialData: 'Lock financial data',
    financialDataLocked: 'Financial data are locked',
    financialAndDelivery: 'Financial & Delivery',
    funnel: 'Funnel',
    fusion: 'Merge',
    gas: 'Fueled',
    generalComment: 'Comments',
    generalInfo: 'General info',
    genericError: 'An error occurred. Please try again later.',
    group: 'Group',
    guestMode: 'You are in "guest" mode',
    guestModeForDeliveryMen:
        'You are in "guest" mode but you are the @:lexicon.delivery.singular person you can change the @:lexicon.delivery.singular fields.',
    guestModeWithAction:
        'You are in "guest" mode, <br>to assign the lead to yourself, please try to contact the customer',
    hasSubmittedPrequal: 'Prequal',
    hasSubmittedPrequalTooltip: 'Prequalification has been submitted',
    hasEti: 'ETI',
    hasEtiTooltip: 'Express Trade-in',
    hasReportedOn: 'Need to remove reported on date to remove the sale date',
    hasShoppingCart: 'This field cannot be edited because a quote is linked to the vehicle',
    hideSensitiveInfoMode: 'Hide sensitive information',
    history: 'History',
    idVerified: 'ID Verified',
    identity: {
        expired: 'ID Verification Expired',
        hasBeenVerified: 'This lead’s identity has been verified.',
        loading: 'Verifying ID',
        notVerified: 'ID Not Verified',
        previouslyVerified: 'This lead’s identity was previously verified.',
        verified: 'ID Verified',
        unavailable: 'ID Verification Unavailable',
    },
    included: 'Included',
    indefinitely: 'Indefinitely',
    info: 'Info',
    inspected: 'Inspected',
    institution: 'Institution',
    institutionVehicle: 'Institution',
    integrationLeadBlockedTooltip: 'Impossible to change lead type coming from an integration',
    invalid: 'Invalid',
    invalidDate: 'Invalid date',
    invalidLeadTypeForServiceLead: 'You cannot choose this type for a lead service',
    inventoryUnitId: 'Inventory unit',
    invoiced: 'Invoiced',
    isSubscribed: 'Subscribed',
    isNotSubscribed: 'Unsubscribed',
    isUnsold: 'You must have a sale to access this option',
    isUnsubscribedAll: 'Unsubscribe all',
    keepThisLead: 'Create as new',
    keyword: 'Keyword',
    language: 'Language',
    lastName: 'Last name',
    lastPresentedDate: 'Last visit date',
    lastUpdated: 'Last updated',
    lead: 'Lead',
    leadAlreadyAssigned: 'You are not assigned to this lead.',
    leadAssociated: 'Lead associated, redirecting',
    leadCannotHaveStatus:
        'The lead cannot have a lost, duplicate or invalid status to access this option',
    leadCompleted: 'Lead completed, redirecting',
    leadCreated: 'Lead created, redirecting',
    leadForm: 'Form',
    leadManagement: 'Lead Management',
    leadMustBeSold: 'The lead must be @:lexicon.sold.singular to be @:lexicon.delivered.singular',
    leadMustBeRenewed:
        'The lead must be @:lexicon.renewed.singular to be @:lexicon.delivered.singular',
    leadMustHaveASoldWantedVehicle:
        'The lead must have a @:lexicon.sold.singular vehicle of interest to add a @:lexicon.delivered.singular date',
    leadRequirementForAction: 'The lead must be {0} to perform this action',
    leadsInSalesJourney: '{count} lead in this sales journey|{count} leads in this sales journey',
    leadxpressEmail: 'Email',
    legend: 'Legend',
    linkedDuplicate: 'Duplicates of this lead',
    longTerm: 'Long term',
    lost: 'Lost',
    loyalty: '@.capitalize:lexicon.loyalty.singular',
    loyaltyTooltip: '@.capitalize:lexicon.loyalty.singular Client ',
    manualCall: 'Manual Call',
    manualSMS: 'Manual SMS',
    callLogCommunication: 'API Phone System',
    mergeFillTooltip: 'The "Complete" function only adds information to the empty CRM fields.',
    mergeLead: 'Merge',
    mergeLeadRenewNote:
        '* If an trade-in vehicle from the source lead does not exist in the @:lexicon.portfolio.singular destination lead, a new @:lexicon.portfolio.singular lead will be created and linked to the destination lead.',
    mergeReplaceTooltip:
        'The "Replace" function replaces the CRM data with the available data from the import for the competing fields without affecting the other fields.',
    messenger: 'Messenger',
    messengerDescription: 'Messenger conversation description',
    met: 'Met',
    minAssignReasonRequest: 'The reason must be at least 10 characters',
    modifyDeliveryDate: 'The @:lexicon.sale.singular must be unchecked to modify this field',
    more: 'More',
    msrp: '(MSRP)',
    mustBeDelivered: 'The lead must be @:lexicon.delivered.singular to access this option',
    name: 'Full name',
    navigationHistory: 'Navigation history',
    navigationHistoryAbr: '@:clientCard.navigationHistory',
    navigationHistoryClickMsg: 'Click to view navigation history',
    navigationHistoryEmpty: 'No navigation history',
    needAppointmentChecked: 'The appointment must be checked to modify this field',
    needAppointmentUnchecked: 'The appointment must be unchecked to modify this field',
    needCommercial: 'Contact us to activate the "F&I" module',
    needCsiUnchecked: 'CSI must be unchecked to modify this field',
    needDeliveredChecked:
        '@.capitalize:lexicon.delivered.singular must be checked to modify this field',
    needDeliveredUnchecked:
        'The @:lexicon.delivery.singular must be unchecked to modify this field.',
    neededDataForRenewal:
        'The auto @:lexicon.portfolio.singular requires an end contract date or the "Cash Deal" modality on the @:lexicon.sold.singular vehicle before this field can be modified.',
    needInvoicedChecked: 'Invoiced must be checked to modify this field',
    needModalityInfo:
        'The @:lexicon.sold.singular vehicle modality must be a cash deal or have an end contract date set',
    needOneCurrentVehicle:
        "A trade-in vehicle with an end contract date or a 'Cash Deal' modality is required to select the @:lexicon.portfolio.singular type",
    needPaymentAndFrequencyEmpty:
        'The balance cannot be set manually when there are values in the payment and frequency fields',
    needPresentedChecked: 'The visit must be checked to modify this field.',
    needPresentedDealerChecked: 'A visit at the dealership is required to modify this field.',
    needPresentedUnchecked: 'The visit must be unchecked to modify this field',
    needRefinancedUnchecked: 'The Buy Out must be unchecked to modify this field',
    needRenewalChecked: 'The @:lexicon.portfolio.singular must be checked to modify this field',
    needRenewalUnchecked:
        'The @:lexicon.portfolio.singular must be unchecked to modify this field.',
    needSaleByPhoneUnchecked:
        'The phone @:lexicon.sale.singular must be unchecked to modify this field.',
    needSaleChecked: 'The @:lexicon.sale.singular must be checked to modify this field',
    needSaleUnchecked: 'The @:lexicon.sale.singular must be unchecked to modify this field.',
    needToBeCommercial: 'You must be a commercial manager to edit this field',
    needToBeDirector: 'You must be a manager to edit this field',
    needVehicleInfoAndStockForSale:
        'You must fill the make, model and stock fields to modify this field',
    needVehicleInfoForSale: 'You must fill the make and model fields to modify this field',
    needVehicleInfoToSelectSoldVehicle:
        'You must fill the make, model and stock fields to select this vehicle',
    newAssociate: 'Associate',
    newest: 'Newest',
    newLead: 'New lead',
    nextDashboardLead: 'Next dashboard lead',
    nextPresentedDate: 'Next revival',
    nextStep: 'Next step',
    noAttachments: 'No attachments',
    noComment: 'No note',
    noCommunication: 'No communication',
    noDescription: 'No description',
    noEmail: 'No email',
    noLeadFound: 'No duplicate match; creating the lead...',
    noMakeModel: 'No vehicle',
    noSelection: 'No selection',
    noSms: 'No SMS',
    notes: 'Notes',
    audioNotesFiles: 'Audio notes & files',
    noteDeleteMessage: 'Are you sure you want to delete this note?',
    notMet: 'Not met',
    notOnLeadRenewal:
        'This field cannot be modify if the type of the lead is @:lexicon.portfolio.singular',
    notSold: 'Not @:lexicon.sold.singular',
    noAdvisorForExport: 'An associate must be assigned to export this lead',
    noAdvisorTitle: 'No associate',
    noDataAvailable: 'No data available',
    nonConsumerInitiated: 'Non-Consumer Initiated',
    noVehicle: 'No vehicle; click the + sign to add one',
    noVehicleFilter: 'No vehicles match the filter',
    numberMustBeMobile: 'The number must be a valid mobile phone.',
    odometerLastVisit: 'Last visit KM',
    oldest: 'Oldest',
    openAutoVance: 'Open Autovance',
    openDeskit: 'Open Deskit',
    openWorkOrderDate: 'W.O. opening',
    openWorkOrderDateTooltip: 'Work Order opening date',
    optOut: 'Opt-out',
    order: 'Order | Orders',
    orderEmpty: 'No Order',
    origin: 'Source',
    originalCreatedAt: 'Original creation date',
    originalEmail: 'See the original email',
    others: 'Others',
    paperwork: 'Paperwork',
    pbsVehicleNoVINText: 'Only vehicles with a VIN will be exported. Do you want to continue ?',
    pbsVehicleNoVINTitle: 'VIN required',
    pending: 'Pending',
    performance: 'Performances',
    personalInfo: "Client's information",
    phone: 'Phone',
    phoneAbr: 'Tel',
    phoneAppointment: 'Call appointment',
    phoneType: {
        home: 'Home phone',
        cell: 'Mobile phone',
        work: 'Work phone',
    },
    plannedEmail: 'Planned email',
    plannedPickUpDate: 'Planned pick up',
    popular: 'Most popular',
    postalCode: {
        CA: 'Postal code',
        US: 'ZIP code',
    },
    preferredPhone: 'Preferred phone number',
    preferredPhoneText: 'Preferred phone number for SMS and marketing communications',
    preferredEmail: 'Preferred email address',
    preferredEmailText: 'Preferred email address for emails and marketing communications',
    prepaid: 'Prepaid',
    prepaidTooltip: 'Prepaid Client',
    prepared: 'Prepared',
    prepared_work_order: 'P.W.O.',
    preparedWorkOrderPlaceholder: 'P.W.O. #12348900',
    preparedWorkOrderTooltip: 'Prepared work order',
    presented: 'Visit',
    presentedDate: 'Visit date',
    previousDashboardLead: 'Previous dashboard lead',
    preQualified: {
        expired: 'Pre-Qualification Expired',
        for: 'Pre-Qualified for',
        forUpTo: 'Pre-Qualified for up to',
        loading: 'Fetching Pre-Qualification',
        notSubmitted: 'Pre-Qualification Not Submitted',
        previouslyPreQualified: 'This lead was previously pre-qualified.',
        title: 'Pre-Qualified',
        unableToProvide:
            'We are unable to provide pre-qualification options at this time due to missing or invalid information submitted by the customer.',
        unavailable: 'Pre-Qualification Unavailable',
    },
    primary: 'Primary',
    primaryContact: 'Primary contact',
    primaryContactOptions: {
        main: 'Full name',
        business: 'Business name',
    },
    setPrimaryVehicleTooltip: 'Set as Primary Vehicle for PDF & Email Generation',
    unsetPrimaryVehicleTooltip: 'Unset as Primary Vehicle for PDF & Email Generation',
    private: 'Private',
    privateNote: 'Private note',
    privateNoteInfo: 'A private note can only be seen by yourself',
    process: 'Process',
    processService: 'Process (Service)',
    progress: 'Progress',
    promisedDate: 'Promised time',
    provider: 'Provider',
    providedBy: 'Provided by',
    province: {
        CA: 'Province',
        US: 'State',
    },
    push: 'Mobile',
    qualification: 'Qualification',
    rating: 'Evaluation',
    ratingComment: 'Comments',
    ratingDeleteMessage: 'Are you sure you want to delete this evaluation?',
    ratingModalTitle: 'Client evaluation',
    ratingTooltip: 'Client evaluation',
    reached: 'Reached',
    readOnly: 'Read Only',
    reassignedCommentTooltip: "Assignment request comments can't be edited",
    record: 'Record',
    recordAgain: 'Redo recording',
    recordDelete: 'This will delete your recording.',
    referrer: 'Referrer',
    refinanced: 'Buy Out',
    refinancedTooltip: 'Option available only for vehicle with leasing modality.',
    refresh: 'Refresh',
    rejoint: 'Reached',
    renewal: '@.capitalize:lexicon.portfolio.singular',
    renewalSuccessful: '@.capitalize:lexicon.portfolio.singular lead created successfully.',
    renewed: '@.capitalize:lexicon.renewed.singular',
    repairDate: 'Repair order date',
    repairOrder: 'Repair order',
    reply: 'Reply',
    replyingTo: 'Replying to',
    reportedNotSold: 'Reported not @:lexicon.sold.singular',
    reportedSold: 'Reported @:lexicon.sold.singular',
    requestSource: 'Request source',
    resetCBBValue: 'Reset Canadian Black Book Value',
    resetCBBValueTitle: 'Do you wish to reset to the Canadian Black Book Value?',
    responseTimeNotApplicableMergedTooltip:
        'The response time is not calculated when other leads have been merged.',
    restore: 'Restore',
    result: '@.capitalize:lexicon.result.singular',
    revivalService: 'Revival',
    roadTest: 'Test drive | Test drives',
    roadTestEmpty: 'No Test drive',
    roadTestAYL: 'Test drive - AYL',
    roadTestTDM: 'Test drive - TDM',
    sale: '@.capitalize:lexicon.sale.singular',
    saleProcess: 'Sale Process',
    saleByPhone: '@.capitalize:lexicon.sale.singular by phone',
    salesJourneyOverviewTitle: "Events included in <strong>{0}</strong>' sales journey",

    salesJourneySeparation: {
        actualSalesJourneyTitle: 'Current sales journey',
        createdOn: 'Created on',
        eventToExtractTitle: 'Event to extract',
        failure: 'Failed to generate the sales journey',
        generate: 'Generate',
        success: 'Sales journey generated successfully',
        title: 'Generate a new sales journey from this event',
    },

    save: 'Save',
    searchingLead: 'Searching for existing leads',
    searchTerm: 'Search term',
    secondContact: '2nd contact',
    secondaryAdvisor: '@.capitalize:lexicon.secondaryAdvisor.singular',
    selectAction: 'Please choose the action to execute',
    selectCorrectVersion: 'Select the correct version',
    sertiPushNoPhoneText: 'The customer must have a phone number',
    sertiPushNoPhoneTitle: 'Phone number required',
    service: 'Service',
    serviceAdvisor: 'Service advisor',
    serviceAgent: 'Service agent',
    serviceIntervalKm: 'Interval',
    serviceMonthlyKm: 'Monthly KM',
    setAsPreferredPhoneText: 'Set as primary phone number for SMS and marketing communications',
    setAsPreferredEmailText: 'Set as primary email for emails and marketing communications',
    setNextPresentedDate:
        'According to the interval and the monthly KM, the next visit date should be on the <strong>{0}</strong>. Do you want to change the current value of <strong>{1}</strong>?',
    sex: 'Gender',
    showAllAutomations: 'Show all automations',
    sms: 'SMS',
    smsDescription: 'Text message description',
    smsDisabled: 'SMS notifications has been deactivated by the request of the manager.',
    smsTheClient: 'SMS',
    sold: '@.capitalize:lexicon.sold.singular',
    soldPrimaryVehicleInformation:
        'Designating a vehicle as sold will automatically set it as the Lead’s Primary Vehicle',
    soldPrimaryVehicleTooltip: "A sold vehicle is automatically set as the Lead's Primary Vehicle",
    soldVehicleDisabled: 'You cannot delete a @:lexicon.sold.singular vehicle',
    source: 'Source',
    state: 'Approval',
    status: 'Status',
    stock: 'Stock',
    storage: 'Storage',
    subscribed: 'Opt-out',
    subscriptionManagement: 'Subscriptions Management',
    succefullyExported: 'Exported successfully',
    exportRequestInProgress: 'Lead export to {0} in progress',
    sureChangeLeadType:
        'Changing the lead type may result in erroneous statistics. Are you sure you want to modify this field?',
    sureMerge:
        'Merging these leads will be irreversible and may result in erroneous statistics. Are you sure you want to proceed?',
    takeOver: 'T.O.',
    takeOverBy: 'T.O. by',
    task: 'Task',
    taskOwner: 'Owner',
    technician: 'Technician',
    timeElapsed: 'Time elapsed',
    timeFrame: 'Purchase intent period',
    total: 'Total',
    twenty_four_hour: '24 hr',
    twentyFourHrTooltip: '24 hr',
    type: 'Type',
    unauthorizedAction: 'You are not allowed to perform this action',
    unauthorizedActionOnField: 'You are not allowed to update this field',
    unfreezedFinancialData: 'Unlock financial data',
    unknown: 'Unknown',
    unsubscribedEmail: 'Unsubscribed from email since {0}',
    unsubscribedPhone: 'Unsubscribed from call since {0}',
    unsubscribedSince: 'Unsubscribed since {0}',
    unsubscribedSms: 'Unsubscribed from SMS since {0}',
    updatedAt: 'Updated',
    updatedBy: 'Updated by',
    user: 'User',
    validateLead: 'Select a lead to associate or to merge or click "Cancel" before continuing',
    validating: 'Validating...',
    valueByCBB: 'The value was defined by CBB with the condition: {0}',
    vehicle: 'Vehicle',
    vehicleExchange: 'Vehicle (Current)',
    vehicleWanted: 'Vehicle (Wanted)',
    vehicleState: 'Vehicle State',
    vehicleEvaluate: 'Vehicle was evaluated',
    vehicleExchangeEndWarrantyDate: 'End warranty',
    vehicleExchangeExtendedWarranty: 'Extended warranty',
    vehicleExchangeLicensePlate: 'License plate',
    vehicleExchangePurchaseDate: 'Purchase date',
    vehicleExchangeRecall: 'Recall',
    vehicleExportedToSerti: 'Vehicle exported to Serti',
    vehicleLeadEventListTooltip: 'View attributed leads linked with this vehicle',
    verifiedSaleUneditable: 'This @:lexicon.sale.singular is verified',
    videoconference: 'Videoconference',
    videoconferenceDescription: 'Videoconference description',
    viewSensitiveInfoMode: 'View sensitive information',
    waitingSale: 'Waiting @:lexicon.sale.singular',
    waitingSaleDisabled: 'The lead should not be @:lexicon.delivered.singular',
    waitingSaleTooltip: 'Force this lead to be considered as a waiting @:lexicon.sale.singular',
    walkAround: 'Walk around',
    walkIn: '@.capitalize:lexicon.walkIn.singular',
    walkInDescription: 'Visit details',
    wantedVehicle: 'Vehicle of Interest',
    willBeAttributed: 'Will be attributed',
    willReplacePrimary: 'Will replace primary',
    workOrder: 'W.O. #',
    workOrderClosureDate: 'W.O. closure',
    workOrderPartialClosureDate: 'W.O. partial closure',
    workOrderTooltip: 'Work Order #',
    writeUp: 'Write-Up',
    you: 'You',

    visit: {
        visit: 'Visit',
        startVisit: 'Start Visit',
        endVisit: 'End Visit',
        visitConfirmation: 'Visit Confirmation',
        completeVisitWith: "You've successfully completed the visit with ",
        visitDate: 'Visit Date',
        startTime: 'Visit Start Time',
        endTime: 'Visit End Time',
        totalTime: 'Total Visit Time : {0}',
        associateAppointment: 'Would you like to update an existing appointment with this visit?',
        cancel: 'Cancel',
        endVisitBtn: 'End Visit',
        ongoing: 'Ongoing Visit',
        completed: 'Completed Visit',
        creator: 'Visit Creator',
        owner: 'Owner',
        addVisitTitle: 'Start a Visit',
        startVisitNow: 'Start Visit Now',
        addPastVisit: 'Add a Past Visit',
        discard: 'Discard',
        addVisit: 'Add Visit',
        appointmentLinkTitle: 'Appointment Updated',
        appointmentLinkText: "Appointment updated and marked as 'show'",
        testDriveLinkTitle: 'Test drive Updated',
        testDriveLinkText: "Test drive updated and marked as 'completed'",
        deliveryLinkTitle: 'Delivery associated with Visit',
        error: {
            time: 'Start time must be before end time',
            getVisit: 'Error while fetching the visit status',
            fetchVisits: 'Error while fetching the visits',
            alreadyEndedOrDiscarded: 'The visit has already ended or been discarded',
            stopVisit: 'The visit could not be ended',
            discardVisit: 'The visit could not be discarded',
            alreadyUnderway: 'A visit is already underway for this lead',
            startVisit: 'The visit could not be started',
            startOrAddVisit: 'The visit could not be started or added',
            alreadyInVisitUser:
                'You already have an ongoing visit with {leadName}. End the visit before starting a new one.',
            alreadyInVisitLead:
                'This client already has an ongoing visit. End the visit before starting a new one.',
            goToLead: 'Go to lead',
        },
        errorStoppingVisit: 'The visit could not be ended',
        errorDiscardingVisit: 'The visit could not be discarded',
    },

    assignation: {
        transferAssignedTooltip: 'Assigned : {0}',
        transferWaitingTooltip: 'Pending : {0}',
    },
    associatedLeads: {
        assignedToMe: 'Assigned to me',
        createAssociatedLead: 'Create associated lead',
        close: 'Close',
        customerSince: 'Customer since {0}',
        collapse: 'Collapse',
        expand: 'Expand',
        filterLeads: 'Filter leads',
        interDealerLeads: 'Inter-Dealer Leads',
        noVehicle: 'No vehicle',
    },
    boxes: {
        clickToCollapse: 'Click to collapse',
        clickToExpand: 'Click to expand',
        collapse: 'Collapse',
        expand: 'Expand',
        filtering: 'Filtering',
        filteringAndSorting: 'Filtering & Sorting',

        activities: {
            title: 'Tasks & Appointments',

            addActivity: 'Add a task or appointment',
            automated: 'Automated',
            canceled: 'Canceled',
            enableCalendarView: 'Enable calendar view',
            enableTimelineView: 'Enable timeline view',
            guests: 'Guest|Guests',
            pendingActivities: '{0} pending task or appointment|{0} pending tasks or appointments',
            taskCreator: 'Task creator',
            upcomingActivities:
                '{0} upcoming task or appointment|{0} upcoming tasks or appointments',
            view: 'View',

            filters: {
                activityType: 'Task or Appointment Type',
                leadType: 'Lead type',
                timelineGroup: 'Group',
            },

            typeAction: {
                appointment: 'Appt',
                call: 'Call',
                csi: 'CSI',
                delivery: 'Vehicle @:lexicon.delivery.singular',
                email: 'Email',
                other: 'Other',
                phone_appointment: 'Phone Appt',
                sms: 'SMS',
                virtual_appointment: 'Virtual Appt',
                test_drive: 'Test drive',
            },
        },
        commercialProducts: {
            title: 'F&I Profits',

            clientMet: 'Client met',
            clientNotMet: 'Client not met',
            commercialSpecifications: 'F&I Specifications',
            freezeFinancialData: 'Block financial data',
            included: 'Included',
            notIncluded: 'Not included',
            product: 'product',
            profit: 'profit',
            sold: 'Sold',
            soldProductsCount: 'Sold Products',
            specifications: 'Specifications',
            groups: {
                insuranceAndWarranty: 'Insurance & Warranty',
                protectionPlan: 'Protection Plan',
            },
        },
        communications: {
            title: 'Communications',

            automated: 'Automated',
            campaign: 'Campaign',
            clickedTime: 'Clicked {0} times',
            edit: 'Edit',
            emailReadOn: 'Email read on {0}',
            exchangeCount: 'Exchange count',
            manual: 'Manual',
            api: 'API',
            planned: 'Planned',
            read: 'Read',
            time: 'time | times',
            unread: 'Unread',
            view: 'View',

            conferences: {
                browserNotSupportingVideoPlaying: 'Your browser does not support video playing.',
                duration: 'Lasted {0}',
                join: 'Join',
                notAuthorizedToJoin: 'You are not authorized to join this videoconference',
                recorded: 'Rec',
                recordedVideoTooltip: 'The videoconference has been recorded',
                recordingAccessDenied: 'You do not have access to this recording',
                recordingVideoTooltip: 'The videoconference will be recorded',
                videoProcessing: 'Video Processing...',
            },

            filters: {
                automation: 'Automation',
                direction: 'Direction',
                emailAttachment: 'Email with attachment',
                method: 'Method',
                type: {
                    title: 'Type',
                    regular: 'Regular',
                },
            },

            ringcentralRecordings: {
                audioUnavailable: 'Audio unavailable or processing',
            },
        },
        financialAndDelivery: {
            reportedOn: 'Reported on',
        },
        general: {
            averageSpendingService: '$ per visit (service)',
            contactPreference: 'Contact Preference',
            details: 'Lead Details',
            generalInfo: 'General Information',
            identity: 'Identity',
            invalidPhoneNumber: 'This phone number is invalid',
            lastVisitService: 'Last visit (service)',
            moreOptions: 'More options',
            noBusiness: 'No business',
            noPreferences: 'No preference',
            validatingPhoneNumber: 'Validating phone number...',
            view: 'View',
            viewBreakdown: 'View Breakdown',

            tabs: {
                contact: 'Contact',
                general: 'General',
            },
        },
        notes: {
            title: 'Notes',

            bookmark: 'Bookmark',
            removeBookmark: 'Remove bookmark',
            deleteConfirmationSingleChild:
                'Are you sure you want to delete this note and the associated one?',
            deleteConfirmationMultipleChildren:
                'Are you sure you want to delete this note and the {0} associates ones?',
            editingNote: 'Editing note',
            editingThisNote: 'Editing this note',
            filters: {
                related: 'Only vehicle notes',
                leadType: 'Lead type',
                noteType: {
                    title: 'Note type',

                    all: 'All',
                    attachment: 'Files',
                    audio: 'Audio',
                    case: 'Case',
                    cases: 'Cases',
                    string: 'Notes',
                    instruction: 'Instructions',
                    reassign: 'Assignment request',
                },
            },
            notAvailableInEditMode: 'Not available in edit mode',
        },
        overview: {
            viewContact: 'View contact',
            viewCustomer: 'View Customer',
            priority: {
                high: 'High priority',
                normal: 'Normal priority',
            },
            noDescription: 'No description',
            noPlannedTask: 'No planned task',
            noExcerpt: 'No excerpt',
            noCommunication: 'No communication',
            noMileage: 'Mileage unknown',
        },
        revisionsLog: {
            title: 'History of changes',
        },
        revival: {
            title: 'Revival',
        },
        salesProgress: {
            title: 'Deal Navigator',
            negativeEquity: 'Negative',
            positiveEquity: 'Positive',
            modal: {
                actions: {
                    markVehicleAs: 'Mark Vehicle As',
                },
                addVehicle: 'Add Vehicle',
                virtualVehicle: {
                    year: 'Year',
                    makeModel: 'Make & Model',
                    modelCode: 'Model Code',
                    specifications: 'Specifications',
                    msrp: 'MSRP',
                    modalCta: 'Calculate Virtual Vehicle',
                    noData: 'Search using Year, Make & Model, or Model Code',
                    createError: 'An error occurred while creating the virtual vehicle',
                },
                tabs: {
                    appraisal: 'Appraisal',
                    dealInformation: 'Deal Information',
                    vehicleDetails: 'Vehicle Details',
                    quote: 'Quote',
                    profit: 'Profit: {0}',
                },
                title: {
                    tradeInVehicle: 'Trade-in Vehicle',
                    wantedVehicle: 'Deal',
                    quote: 'Quote',
                },
                section: {
                    additionalInformation: 'Additional Information',
                    appraisal: 'Appraisal',
                    customFields: 'Custom Fields',
                    existingPaymentsAndContracts: 'Existing Payments and Contract',
                    financialInformation: 'Financial Information',
                    financialAndWarranty: 'Financial & Warranty',
                    financial: 'Financial',
                    payment: 'Payment',
                    allowanceAndResidual: 'KM Allowance And Residual',
                    contractDetails: 'Contract Details',
                    overview: 'Overview',
                    priceAndContract: 'Price and contract',
                    pricingDetails: 'Pricing Details',
                    warranty: 'Warranty',
                    extendedWarranty: 'Extended Warranty',
                    serviceFollowUp: 'Service Follow-Up',
                    vehicleCondition: 'Vehicle Condition',
                    vehicleInformation: 'Vehicle Information',
                    apply: 'Apply',
                    onlineCustomerQuote: 'Online Customer Quote on AutoTrader.ca',
                    onlineTraderQuote: 'Online Quote on AutoTrader.ca',
                    internalDealerQuote: 'Internal Dealer Quote',
                    internalDealerQuoteTooltip:
                        'To view the online customer quote, open this deal in TraderPanel.',
                    dealOnlyVisibleToDealer:
                        'This deal is only visible to the dealer, and does not impact the online AutoTrader quote.',
                    internalDealerTradeIn: 'Internal Dealer Trade-in',
                    doesNotImpactOnlineTradeIn:
                        'The following inputs do not affect the online trade-in on AutoTrader.ca.',
                    tradeInFinancial: {
                        title: 'Online Customer Trade-in on AutoTrader.ca',
                        estimate: 'Estimate',
                        estimateTooltip: 'Approximate value of the trade-in vehicle.',
                        providedByAutotrader: 'Provided by AutoTrader.ca',
                        eti: 'Express Trade In',
                        owing: 'Balance / Lien',
                        offer: 'Offer Made',
                    },
                    applyQuoteDrsInformation: 'Apply Online Quote to Internal Dealer Quote',
                    applyTradeInDrsInformation: 'Apply Online Trade-In to Internal Dealer Trade-In',
                    quote: {
                        quoteBreakdown: 'Quote Breakdown',
                        dueOnDelivery: 'Due on Delivery',
                        paymentTypeOverview: 'Payment Type Overview',
                        insuranceWarranty: 'Insurance & Warranty',
                        registrantCompany: 'Registrant Company',
                        onlineQuote: 'Online Customer Quote',
                        errors: {
                            invalidValueRestored:
                                'Value for {0}{1} failed validation. Previous value restored.',
                        },
                    },
                    profit: {
                        vehicle: 'Profit on vehicle',
                        accessories: 'Profit on Accessories/Options',
                        total: 'Total profit',
                    },
                },
            },
            tabs: {
                deal: 'Deal',
                quote: 'Quote',
                tradeIn: 'Trade-in',
                presentation: 'Presentation',
                billOfSale: 'Sale',
                financialAndInsuranceAndCredit: 'Credit',
                delivery: 'Delivery',
                custom: 'Custom',
            },
            presentation: {
                sections: {
                    dealershipPresentation: 'Dealership Presentation',
                    vehiclePresentation: 'Vehicle Presentation',
                    customFields: 'Custom Fields',
                },
                copyLink: 'Copy Link to Online Appointment Booking Form',
                stepToComplete: 'Confirm customer Visit to complete this step.',
                twentyFourHr: 'Follow-up post 24 hours',
            },
            billOfSale: {
                sections: {
                    billOfSale: 'Bill of Sale',
                    customerDeposit: 'Customer Deposit',
                    customFields: 'Custom Fields',
                },
                billOfSaleCreated: 'Bill of Sale created',
                billOfSaleSentToCustomer: 'Sent to customer',
                billOfSaleSignedByCustomer: 'Signed by customer',
                copyLink: 'Copy Link to Deposit Form',
                customerDepositReceived: 'Deposit received',
                customerReceiptSent: 'Receipt sent',
                stepToComplete:
                    'Mark a vehicle as @.capitalize:lexicon.sold.singular to complete this step.',
                viewDetails: 'View details',
            },
            quote: {
                cashDeal: 'Cash Deal',
                originalLeadInfo: {
                    tooltipTitle: 'Original Lead Information',
                    provider: 'Provider: {0}',
                },
                paymentTypeOverview: {
                    leased_amount: 'Leased Amount',
                    borrowing_cost: 'Borrowing Cost',
                    amount_to_maximum: 'Amount to Maximum',
                    amount_to_maximum_tooltip: 'Amount to Maximum',
                    taxable_amount: 'Taxable Amount',
                    luxury_tax: 'Luxury Tax',
                    gst: 'GST',
                    pst: 'PST',
                    ppsa_fee: 'P.P.S.A.',
                    gas_fees: 'Gas Fees',
                    license_fees: 'License Fees',
                    insurance_included: 'Insurance',
                    included: 'Included',
                    not_included: 'Not Included',
                    gap_warranty_included: 'GAP Warranty',
                    sub_total: 'Sub Total',
                    manufacturer_rebates: 'Manufacturer Rebates',
                    cash_down: 'Cash Down',
                    financed_amount: 'Financed Amount',
                    residual_amount: 'Residual Amount',
                    leaseOverview: 'Lease Overview',
                    financeOverview: 'Finance Overview',
                    futureValueOverview: 'Future Value Overview',
                },
                pricingGrid: {
                    lease: 'Lease',
                    manufacturerFinancing: 'Manufacturer Financing',
                    bankFinancing: 'Bank Financing',
                    futureValue: 'Future Value',
                    cash: 'Cash Deal',
                    total: 'Total',
                    down_payment_after_tax: 'Down Payment (After tax)',
                    total_amount: 'Total Amount',
                    paymentFrequency: 'Payment Frequency',
                    kmAllowancePerYear: 'KM Allowance per Year',
                    leaseAdvancePayment: 'Lease Advance Payment',
                    weekly: 'Weekly',
                    biweekly: 'Bi-Weekly',
                    monthly: 'Monthly',
                    leaseTerm: 'Lease Term',
                    rate: 'Rate',
                    residualPercent: 'Residual %',
                    residualDollar: 'Residual $',
                    totalKm: 'Total KM',
                    payment: 'Payment',
                    taxes: 'Taxes',
                    dueOnDelivery: 'Due on Delivery',
                    financeTerm: 'Finance Term',
                    amortization: 'Amortization',
                    residual: 'Residual',
                    bank: 'Bank',
                },
                dueOnDelivery: {
                    selling_price: 'Selling Price',
                    security_deposits: 'Security deposits',
                    cash: 'Cash',
                    personal_property_security_act: 'P.P.S.A.',
                    air_conditioning_tax: 'Air Conditioning Tax',
                    luxury_tax: 'Luxury Tax',
                    taxable_amount: 'Taxable Amount',
                    first_payment: 'First Payment',
                    gap_warranty_included: 'Gap Warranty',
                    license_fees: 'License Fees',
                    delivery_fees: 'Delivery Fees',
                    gas_fees: 'Gas Fees',
                    down_payment: 'Down Payment',
                    admin_fees: 'Administration Fees',
                    other_fees: 'Other Fees',
                    tire_tax: 'Tire Tax',
                    omvic_amvic: 'OMVIC/AMVIC',
                    service_contract: 'Service Contract',
                    dealer_accessories: 'Dealer Accessories',
                    delivery_from_client: 'Delivery (from Client)',
                    total_delivery_from_client: 'Total Delivery (from Client)',
                    rebate_from_manufacturer_at_delivery: 'Rebate from Manufacturer (at Delivery)',
                    total_due_on_delivery: 'Due on Delivery Total',
                    grand_total: 'Grand Total',
                    included: 'Included',
                    not_included: 'Not Included',
                },
                quoteBreakdown: {
                    msrp: 'MSRP',
                    selling_price: 'Selling Price',
                    retail_price: 'Retail Price',
                    hebdo_guide: 'Hebdo Guide',
                    down_payment: 'Down Payment',
                    freight: 'Freight',
                    incentives_pre_tax: 'Incentives (Before Tax)',
                    dealer_accessories: 'Dealer Accessories',
                    search_accessories: 'Search accessories',
                    accessories_count: '({count} Accessory)|({count} Accessories)',
                    name_and_description: 'Name & Description',
                    apply_price: 'Apply Price',
                    apply_accessories_tooltip: 'Select how this accessory is applied to the quote.',
                    retail_price_tooltip: 'Manufacturer suggested retail price.',
                    payments: 'Payments',
                    cod: 'COD',
                    view_description: 'View description',
                    hide_description: 'Hide description',
                    total_payments: 'Total (Payments)',
                    total_cod: 'Total (COD)',
                    dealer_accessories_empty_state: 'No accessories found.',
                    accessories_load_error: 'Failed to load dealer accessories. Please try again.',
                    accessories_update_error:
                        'Failed to apply dealer accessories. Please try again.',
                    add_temporary_accessory: 'Add a Temporary Accessory',
                    temporary_accessory: {
                        add_title: 'Add a temporary accessory for this quote',
                        edit_title: 'Edit a temporary accessory for this quote',
                        add_button: 'Add Temporary Accessory',
                        save_changes: 'Save Changes',
                        delete: 'Delete this Temporary Accessory',
                        cancel: 'Cancel',
                        names_section: 'Accessory Name',
                        description_section: 'Description',
                        pricing_section: 'Pricing Information',
                        name_en: 'Accessory Name (EN)',
                        name_fr: 'Accessory Name (FR)',
                        description_en: 'Description (EN)',
                        description_fr: 'Description (FR)',
                        cost_price: 'Cost Price',
                        apply_price_to: 'Apply Price To',
                        badge: 'Temporary',
                        edit_action: 'Edit Temporary Accessory',
                    },
                    apply_accessories: 'Apply Accessories',
                    pdi: 'PDI',
                    air_conditioning_tax: 'Air Conditioning Tax',
                    apply_freight_and_air_conditioning_tax: 'Freight and Air Conditioning Tax',
                    cash_tax_included: 'Cash (Tax Included)',
                    accessories_header: 'Accessories & Options',
                    protection_plans_header: 'Protection Plans',
                    trade_in_header: 'Trade-In',
                    trade_in_total_subheader: 'Trade In Total',
                    taxes_header: 'Taxes & Fees',
                    taxes_cta: 'Taxes',
                    luxury_tax_name: 'Federal Luxury Tax',
                    luxury_tax_intro:
                        'To remove luxury tax from the transaction, the vehicle must meet one of the following conditions:',
                    luxury_tax_condition_1: 'The vehicle has a GVWR higher than 3856 KG',
                    luxury_tax_condition_2: 'Firefighter',
                    luxury_tax_condition_3: 'Ambulance',
                    luxury_tax_condition_4: 'Police',
                    luxury_tax_condition_5: 'Hearse',
                    luxury_tax_warning:
                        'Activix will not be responsible if you remove the luxury tax by mistake.',
                    sales_tax: 'Sales Tax',
                    taxes_load_error: 'Failed to load taxes. Please try again.',
                    taxes_update_success: 'Taxes updated successfully.',
                    taxes_update_error: 'Failed to update taxes. Please try again.',
                    capitalized_options: 'Capitalized Options',
                    non_capitalized_options: 'Non-Capitalized Options',
                    service_contract: 'Service Contract',
                    wear_and_tear: 'Wear & Tear',
                    appearance_protection: 'Appearance Protection',
                    custom_after_sales_products: 'Custom After Sales Products',
                    total_selling_price: 'Total Selling Price',
                    incentives_tax_included: 'Incentives (After Tax)',
                    incentives: 'Incentives',
                    trade_in_cta: 'Add a Trade-In Vehicle',
                    trade_in_amount: 'Trade-In Amount',
                    trade_in_lien: 'Trade-In Lien',
                    lease_debt: 'Lease Debt',
                    admin_fees: 'Administration Fees',
                    admin_fees_apply: 'Apply Fees',
                    admin_fees_total: 'Total',
                    admin_fees_update_error: 'Failed to update administration fees',
                    total_admin_fees: 'Total Administration Fees',
                    admin_fees_payments: 'Administration Fees applied to Payments',
                    admin_fees_cash_delivery: 'Administration Fees applied to Cash on Delivery',
                    admin_fees_cash: 'Administration Fees applied for Cash',
                    license_fees: 'License Fees',
                    other_fees: 'Other Fees',
                    demo_km: 'Demo KM',
                },
                paymentTypes: {
                    lease: 'Lease',
                    oem: 'Manufacturer Financing',
                    bank: 'Bank Financing',
                    future_value: 'Future Value',
                    cash: 'Cash Deal',
                    all: 'All',
                },
                incentiveTypes: {
                    pre_tax: 'Before Tax',
                    tax_included: 'After Tax',
                    rebate_on_rate: 'Rebate on Rate',
                },
                modals: {
                    demoKm: {
                        title: 'Demo KM',
                        text: 'Do you wish to apply the Freight and Air Conditioning Tax charges for this demo vehicle?',
                        freight_air_conditioning_tax: 'Freight and Air Conditioning Tax',
                    },
                    multipleSecurityDeposits: {
                        title: 'Multiple Security Deposits',
                        leaseTermLabel: 'Lease Term',
                        leaseTermFallback: 'Not available',
                        totalDepositRates: 'Total Deposit & Rates',
                        columns: {
                            multiplier: 'Multiple Security Deposit',
                            totalDeposit: 'Total Deposit',
                            rate: 'Rate %',
                        },
                        customDeposit: 'Custom Deposit',
                        totalLabel: 'Total',
                        removeButton: 'Remove Security Deposit',
                    },
                    licenseFees: {
                        title: 'License Fees',
                        applyFees: 'Apply License Fees',
                        applyTo: 'Apply Fees to',
                        payments: 'Payments',
                        delivery: 'COD',
                        fetchError: 'Failed to fetch license fee. Please try again.',
                    },
                    otherFees: {
                        title: 'Other Fees',
                        columns: {
                            name: 'Name',
                            applyFees: 'Apply Fees',
                            amount: 'Amount',
                            addTaxes: 'Add Taxes',
                        },
                        emptyStateMessage: 'No other fees available.',
                        totalPayments: 'Total (Payments)',
                        totalCOD: 'Total (COD)',
                        applyButton: 'Apply Fees',
                        applicability: {
                            payment: 'Payments',
                            delivery: 'COD',
                        },
                        errors: {
                            fetch: 'Failed to fetch other fees. Please try again.',
                        },
                    },
                    incentives: {
                        title: 'Incentives',
                        incentivesCount: '({count} Incentive)|({count} Incentives)',
                        searchPlaceholder: 'Search Incentives',
                        columns: {
                            nameAndDescription: 'Name & Description',
                            compatiblePaymentTypes: 'Compatible Payment Types',
                            amount: 'Amount',
                            type: 'Type',
                        },
                        emptyStateMessage: 'No incentives available.',
                        paymentTypeLabel: 'Payment Type',
                        totalBeforeTaxLabel: 'Total (Before Tax)',
                        totalAfterTaxLabel: 'Total (After Tax)',
                        applyButton: 'Apply Incentives',
                        seeMore: 'See More',
                        seeLess: 'See Less',
                        viewBrochure: 'View Brochure',
                        incompatiblePaymentTypeMessage:
                            'This incentive is not applied to the quote since it is not compatible with the selected payment type: {paymentType}.',
                        conflict: {
                            title: 'Incentive Conflict',
                            addingWillRemove:
                                'Adding <strong>{incentiveName}</strong> will <strong>remove</strong> the following incentive(s):',
                            addSelectedButton: 'Add Selected Incentive',
                            keepExistingButton: 'Keep Existing Incentive(s)',
                            incompatibleWarning:
                                'Please note that <strong>{incentiveName}</strong> incentive does not apply to the quote since it is not compatible with the selected payment type: {paymentType}.',
                        },
                        errors: {
                            fetch: 'Failed to fetch incentives.',
                        },
                    },
                    tradeIn: {
                        addNewTradeInError: 'Failed to add new trade-in vehicle. Please try again.',
                        addNewTradeInVehicleModalTitle: 'Add New Trade-In Vehicle',
                        addTradeInManually: 'Add a Trade-In Vehicle Manually',
                        addVehicle: 'Add Vehicle',
                        applyTradeIn: 'Apply Trade-In',
                        newVehicle: 'New Vehicle',
                        tradeInLimitTooltip:
                            'You can only select a maximum of 2 vehicles for trade-in.',
                        tradeInsUpdateError: 'Failed to update trade-ins. Please try again.',
                        tradeInVehicleListModalTitle: 'Trade-In',
                        vehicleCount: '({count} vehicle) | ({count} vehicles)',
                    },
                    options: {
                        capitalizedOptionsTitle: 'Capitalized Options',
                        searchPlaceholder: 'Search Options',
                        nonCapitalizedOptionsTitle: 'Non-Capitalized Options',
                        optionsCount: '({count} option) | ({count} options)',
                        name: 'Name',
                        optionCode: 'Option Code',
                        capitalizedAmount: 'Capitalized Amount',
                        priceInstalled: 'Price Installed',
                        sellingPrice: 'Selling Price',
                        totalSellingPrice: 'Total Selling Price',
                        totalCapitalizedAmount: 'Total Capitalized Amount',
                        applyOptions: 'Apply Options',
                        emptyStateMessage: 'No options available.',
                        tooltips: {
                            priceInstalled:
                                'Price includes the cost of the option and its installation on the vehicle.',
                            capitalizedAmount: 'Amount use for the residual value calculation.',
                        },
                    },
                    shareQuote: {
                        title: 'Share Quote',
                        description: 'Select the type of Quote you would like to share:',
                        singleTerm: {
                            title: 'Single Term Quote',
                            description:
                                'Present a single term and financing option for this vehicle.',
                        },
                        multipleTerms: {
                            title: 'Multiple Terms Quote',
                            description:
                                'Present and compare various terms available for this vehicle.',
                        },
                        actions: {
                            preview: 'Preview',
                            print: 'Print',
                            emailQuote: 'Email Quote',
                        },
                        multipleTermsSection: {
                            helperText:
                                'You can select up to {max} different payment options and terms.',
                            limitReached:
                                "You've selected the maximum of {max} different payment options.",
                        },
                    },
                },
            },
            deal: {
                errors: {
                    fetchVehiclesFailed: 'Failed to load vehicles. Please try again.',
                },
                sections: {
                    noDealTitle: 'No deals yet',
                    noQuoteTitle: 'No quotes yet',
                    addVehicleText: 'Add a vehicle first to start building a deal',
                    pickVehicleForQuoteText: 'Pick a vehicle first to build a quote',
                    addVehicleTextButton: 'Add Vehicle',
                    filterVehiclesTextButton: 'Filter & Sort',
                },
                stepToComplete:
                    'Mark a vehicle as @.capitalize:lexicon.sold.singular to complete this step.',
                listing: {
                    title: 'Vehicles of Interest',
                    vehicleInformation: {
                        testDrive: 'Test Drive',
                        soldToADifferentLead:
                            '@.capitalize:lexicon.sold.singular to a different lead',
                        delivered: '@.capitalize:lexicon.delivered.singular',
                        refinanced: 'Refinanced',
                        renewed: '@.capitalize:lexicon.renewed.singular',
                        sold: '@.capitalize:lexicon.sold.singular',
                        soldOn: '@.capitalize:lexicon.sold.singular on',
                        cancelled: 'Cancelled',
                        cancelledOn: 'Cancelled on',
                        orderStatus: {
                            pending: 'Pending',
                            confirmed: 'Confirmed',
                            deliveryPlanning: 'Delivery Planning',
                            expired: 'Expired',
                        },
                        payment: 'Payment',
                        primaryVehicleTooltip: 'Primary Vehicle for PDF & Email Generation',
                        rate: 'Rate',
                        stock: 'Stock #',
                        term: 'Term',
                        modality: {
                            cash: 'Cash',
                            leasing: 'Lease',
                            financing: 'Finance',
                        },
                        pill_payment_type: {
                            cash: 'Cash',
                            lease: 'Lease',
                            bank: 'Finance',
                            oem: 'Manufacturer Financing',
                            future_value: 'Future Value',
                        },
                        frequency: {
                            bi_monthly: 'Semi-Monthly',
                            monthly: 'Month',
                            one_payment: 'One Payment',
                            two_weeks: 'Bi-Weekly',
                            weekly: 'Weekly',
                        },
                    },
                    actions: {
                        title: 'Actions',
                        viewDeal: 'View Deal',
                        viewQuote: 'View Quote',
                        vehicleDetails: 'Vehicle Details',
                        deleteVehicle: 'Delete Vehicle',
                        setPrimaryVehicle: 'Set as Primary Vehicle',
                        unsetPrimaryVehicle: 'Unset as Primary Vehicle',
                        setPrimaryVehicleTooltip:
                            'Set as Primary Vehicle for PDF & Email Generation',
                        unsetPrimaryVehicleTooltip:
                            'Unset as Primary Vehicle for PDF & Email Generation',
                        soldPrimaryVehicleTooltip:
                            "A sold vehicle is automatically set as the Lead's Primary Vehicle",
                        markAsSold: 'Mark as @.capitalize:lexicon.sold.singular',
                        markAsUnsold: 'Remove @.capitalize:lexicon.sold.singular status',
                        createBillOfSale: 'Create Bill of Sale',
                        shareQuote: 'Share Quote',
                        quoteForDifferentProvince: 'Quote for a Different Province',
                    },
                    footer: {
                        manageInTrader: 'Manage in Trader Panel',
                        customerIsCustomizing:
                            'The customer is customizing this deal on AutoTrader.ca',
                        customerView: 'Customer View',
                        copyCustomerLink: 'Copy Customer Link',
                    },
                },
                addVehicleChoices: {
                    newInventory: 'New Inventory',
                    usedInventory: 'Used Inventory',
                    virtualVehicle: 'Calculate Virtual Vehicle',
                    addManually: 'Add a Vehicle Manually',
                },
            },
            financialAndInsuranceAndCredit: {
                sections: {
                    creditApplication: 'Credit Application',
                    customFields: 'Custom Fields',
                },
                copyLink: 'Copy Link to Credit Application Form',
                lenderApproval: 'Lender Approval',
                institution: 'Financial Institution',
                clientApproval: 'Client Approval',
                refinanced: 'Refinanced',
                stepToComplete: 'Confirm Client Approval status to complete this step.',
            },
            delivery: {
                sections: {
                    vehiclePreparation: 'Vehicle Preparation',
                    customerCommunication: 'Customer Communication',
                    customFields: 'Custom Fields',
                },
                gas: 'Fueled',
                inspected: 'Inspected',
                prepared: 'Prepared',
                preparedWorkOrder: 'Work Order',
                stepToComplete: 'Confirm vehicle was Delivered to complete this step.',
            },
            tradeIn: {
                stepToComplete: 'Confirm trade-in Appraisal status to complete this step.',
                listing: {
                    title: 'Trade-in Vehicles',
                    addVehicle: 'Add Vehicle',
                    vehicleInformation: {
                        equity: 'Equity',
                        equityTooltip: 'Trade-in amount less the lien (debt) on the vehicle.',
                        appraisal: 'Appraisal value',
                        appraisalTooltip: 'Value of the vehicle after evaluation.',
                        marketValue: 'Market Value',
                        resale: 'Resale value',
                        resaleTooltip: 'Value of the vehicle on the market.',
                    },
                    actions: {
                        viewAppraisal: 'View Appraisal',
                        vehicleDetails: 'Vehicle Details',
                        deleteVehicle: 'Delete Vehicle',
                    },
                },
            },
        },
        salesProcess: {
            beBack: 'Be-Back',
            deliveryPrepDate: 'Vehicle here on',
            takeOver: 'Take-Over',
            waitingSale: 'Waiting @:lexicon.sale.singular',

            progress: {
                appointmentScheduled: 'Appointment scheduled',
                appointmentScheduledWithDate: 'Appointment scheduled on {0}',
                clientVisited: 'Client visited',
                clientVisitedWithDate: 'Client visited on {0}',
            },
        },
        serviceProcess: {
            title: 'Service Process',

            description: 'Description',
            price: 'Price',
            product: 'Product',
            sold: 'Sold',
            time: 'Time',
        },
        serviceProducts: {
            title: 'Sold Services',

            totalTime: 'Total time',
            workOrder: 'Work Order #',
        },
        vehicles: {
            currentVehiclesTitle: 'Trade-in Vehicle | Trade-in Vehicles',
            wantedVehiclesTitle: 'Vehicle of Interest | Vehicles of Interest',
            noCurrentVehicleTitle: ' No Trade-in Vehicle',
            noWantedVehicleTitle: 'No Vehicle of Interest',

            appraisalDate: 'Appraisal date',
            appraisalValue: 'Appraisal value',
            appraiser: 'Appraisal manager',
            budgetRange: 'Budget range',
            damageValue: 'Damage value',
            details: 'Details',
            endExtendedWarrantyDate: 'End extended warranty',
            endExtendedWarrantyMileage: 'End extended warranty KM',
            filtersResetOnVehicleCreation:
                'Current filters will be reset after adding the vehicle. Do you want to continue with the vehicle creation?',
            lengthRange: 'Length range',
            moreInfo: 'More info',
            negativeEquity: 'Negative equity',
            positiveEquity: 'Positive equity',
            pricingOverview: 'Pricing overview',
            serviceFollowUp: 'Service Follow-up',
            stockToBeDefined: 'Stock TBD',
            totalRepairs: 'Total repairs',
            yearsRange: 'Years range',

            contractWidget: {
                cashdeal: '{amount} cashdeal',
                missingContractInfo: 'Missing contract information',
                missingEndContractDate: 'Missing end contract date',
                missingFrequency: 'Missing frequency',
                missingPayment: 'Missing payment',
                missingPaymentInfo: 'Missing payment information',
                missingPrice: 'Missing price',
                missingRate: 'Missing rate',
                missingTerm: 'Missing term',
                noCashdown: 'No cashdown',
            },

            filters: {
                polestarVehicleState: 'State',
                sold: '@:clientCard.sold',
                stockNumber: '# Stock',
                stockState: 'Stock state',
                vin: 'VIN',
            },

            noModalityInfo: 'Unknown modalities',
            noVinInfo: 'Unknown VIN',

            tabs: {
                appraisal: 'Appraisal',
                info: 'Info',
                priceAndContract: 'Price & Contract',
                quote: 'Quote',
            },
        },
    },
    countries: {
        CA: 'Canada',
        US: 'United States',
        BE: 'Belgium',
    },
    customFieldSections: {
        group: {
            lead: 'Lead',
            vehicleExchange: 'Trade-in Vehicle',
            vehicleWanted: 'Vehicle of Interest',

            short: {
                lead: 'Lead',
                vehicleExchange: 'V. actuel',
                vehicleWanted: 'V. recherché',
            },
        },

        billOfSale: '@:clientCard.boxes.salesProgress.tabs.billOfSale',
        dealNavigatorDelivery: 'Delivery',
        financialAndInsuranceAndCredit:
            '@:clientCard.boxes.salesProgress.tabs.financialAndInsuranceAndCredit',
        generalInfo: '@:clientCard.generalInfo',
        dealNavigatorPresentation: 'Presentation',
        dealNavigatorSale: 'Sale',
        dealNavigatorCredit: 'Credit',
        wantedVehicleDetails: 'Vehicle Details',
        wantedVehicleDealInformation: 'Deal Information',
        exchangeVehicleDetails: 'Vehicle Details',
        exchangeVehicleAppraisal: 'Appraisal',
        processService: '@:clientCard.processService',
        funnel: '@:clientCard.funnel',
        dollarAndLost: '@:clientCard.dollarAndLost',
    },
    event: {
        callCount: 'Call count',
        event: 'Event',
        segment: 'Segment',
    },
    emptyState: {
        activityTitle: 'No activities',
        activityDescription: 'There are no tasks related to this lead.',
        activityNoMatchDescription: 'There are no tasks matching the filters.',
        communicationTitle: 'No communications',
        communicationDescription: 'There are no communications related to this lead.',
        communicationNoMatchDescription: 'There are no communications matching the filters.',
        noteTitle: 'No notes',
        noteDescription: 'There are no notes related to this lead.',
        noteNoMatchDescription: 'There are no notes matching the filters.',
        revisionsLogTitle: 'No history of changes',
        revisionsLogDescription: 'There is no history of changes for this lead.',
        tradeInTitle: 'No Trade-In yet',
        tradeInDescription: 'Add a Vehicle first to get started',
        tradeInAction: 'Add a Vehicle',
        vehicleExchangeTitle: 'No Trade-in Vehicle',
        vehicleExchangeDescription: 'This lead has no Trade-in Vehicle.',
        vehicleExchangeNoMatchDescription: 'There are no Trade-in Vehicle matching the filters.',
        vehicleWantedTitle: 'No Vehicle of Interest',
        vehicleWantedDescription: 'This lead has no Vehicle of Interest.',
        vehicleWantedNoMatchDescription: 'There are no Vehicle of Interest matching the filters.',
        visitTitle: 'No active visits',
    },
    leadVehicleAccidented: {
        frontBumper: 'Front bumper',
        frontDoorDriver: 'Front door driver',
        frontDoorPassenger: 'Front door passenger',
        frontPanelDriver: 'Front panel driver',
        frontPanelPassenger: 'Front panel passenger',
        hood: 'Hood',
        others: 'Others',
        rearBumper: 'Rear bumper',
        rearDoorDriver: 'Rear door driver',
        rearDoorPassenger: 'Rear door passenger',
        rearPanelDriver: 'Read panel driver',
        rearPanelPassenger: 'Rear panel passenger',
        total: 'Total',
        windshield: 'Windshield',
    },
    products: {
        air_filter: 'Air Filter',
        alignment: 'Align.',
        anti_theft: 'Anti theft',
        body: 'Body',
        brakes: 'Brakes',
        burn_protection: 'Burn protection',
        chiselling: 'Chiselling',
        diagnostic: 'Diagnost.',
        event: 'Event',
        extended_warranty: 'Extended warranty',
        financing: 'Financing',
        financing_cash_back: 'Financing cash back',
        flame_quard_protection: 'Flame Guard protection',
        in_turn: "Who's Next",
        injection: 'Injection',
        ins_filling: 'Replacement ins.',
        ins_health: 'Health insurance',
        ins_invalidity: 'Invalidity insurance',
        ins_life: 'Life insurance',
        ins_rental: 'Leasing insurance',
        leather_tissu_interior_treatment: 'Leather & cloth interior treatment',
        maintenance_a: 'Maint. A',
        maintenance_b: 'Maint. B',
        maintenance_c: 'Maint. C',
        maintenance_d: 'Maint. D',
        maintenance_recommended: 'Maint. Recomm.',
        mouse_repellent: 'Mouse repellent',
        niotext: 'NioText',
        smsModule: 'SMS Module',
        oil_filter: 'Oil & Filter',
        other: 'Other',
        others: 'Others',
        paint_treatment: 'Paint treatment',
        parts: 'Parts',
        pef: 'PEF',
        pellicule: '3M pellicule',
        pep: 'PEP',
        pollen_filter: 'Pollen Filter',
        pre_paid_maintenance: 'PPM',
        renewal: '@.capitalize:lexicon.portfolio.singular',
        roof_treatment: 'Roof treatment',
        rustproofing: 'Rustproofing',
        sale_table: '@.capitalize:lexicon.sale.plural Board',
        seat_protection: 'Seat protection',
        service: 'Service',
        starter: 'Remote starter',
        tires: 'Tires',
        transmission: 'Transmiss.',
        walk_in: '@.capitalize:lexicon.walkIn.singular',
        wash: 'Wash',
        wheel_protection: 'Wheel protection',
        window_tint: 'Window tint',
        windshield_treatment: 'Windshield treatment',
    },
    provinces: {
        CA: {
            AB: 'Alberta',
            BC: 'British Columbia',
            MB: 'Manitoba',
            NB: 'New Brunswick',
            NL: 'Newfoundland',
            NS: 'Nova Scotia',
            NT: 'Northwest Territories',
            NU: 'Nunavut',
            ON: 'Ontario',
            PE: 'Prince Edward Island',
            QC: 'Quebec',
            SK: 'Saskatchewan',
            YT: 'Yukon',
        },

        BE: {
            AN: 'Antwerp',
            BRU: 'Brussels-Capital Region',
            OV: 'East Flanders',
            VB: 'Flemish Brabant',
            LI: 'Limburg',
            WV: 'West Flanders',
            BW: 'Walloon Brabant',
            HT: 'Hainaut',
            LG: 'Liège',
            LX: 'Luxembourg',
            NM: 'Namur',
        },

        US: {
            AK: 'Alaska',
            AL: 'Alabama',
            AR: 'Arkansas',
            AS: 'American Samoa',
            AZ: 'Arizona',
            CA: 'California',
            CO: 'Colorado',
            CT: 'Connecticut',
            DC: 'District of Columbia',
            DE: 'Delaware',
            FM: 'Federated States of Micronesia',
            FL: 'Florida',
            GA: 'Georgia',
            GU: 'Guam',
            HI: 'Hawaii',
            IA: 'Iowa',
            ID: 'Idaho',
            IL: 'Illinois',
            IN: 'Indiana',
            KS: 'Kansas',
            KY: 'Kentucky',
            LA: 'Louisiana',
            MA: 'Massachusetts',
            MD: 'Maryland',
            ME: 'Maine',
            MH: 'Marshall Island',
            MI: 'Michigan',
            MN: 'Minnesota',
            MO: 'Missouri',
            MP: 'Northern Mariana Islands',
            MS: 'Mississippi',
            MT: 'Montana',
            NC: 'North Carolina',
            ND: 'North Dakota',
            NE: 'Nebraska',
            NH: 'New Hampshire',
            NJ: 'New Jersey',
            NM: 'New Mexico',
            NV: 'Nevada',
            NY: 'New York',
            OH: 'Ohio',
            OK: 'Oklahoma',
            OR: 'Oregon',
            PA: 'Pennsylvania',
            PR: 'Puerto Rico',
            PW: 'Palau',
            RI: 'Rhode Island',
            SC: 'South Carolina',
            SD: 'South Dakota',
            TN: 'Tennessee',
            TX: 'Texas',
            UT: 'Utah',
            VA: 'Virginia',
            VI: 'Virgin Islands',
            VT: 'Vermont',
            WA: 'Washington',
            WI: 'Wisconsin',
            WV: 'West Virginia',
            WY: 'Wyoming',
        },
    },
    services: {
        averageSpending: '$ per visit',
        averageSpendingTooltip: 'Average spending per visit',
        cleaning: 'Cleaned',
        inspection: 'Test drive / Inspection',
        intention: 'Intention',
        minutes: 'Minutes',
        note: 'Note',
        price: 'Price',
        fiProfit: 'F&I Profit',
        reachedClient: 'Reached client',
        soldServices: '@.capitalize:lexicon.sold.singular services',
        time: 'Time',
        transport: 'Transport',
        walkAround: 'Walk-around',

        transports: {
            courtesy: 'Courtesy',
            drop: 'Drop',
            limousine: 'Limousine',
            other: 'Other',
            renting: 'Renting',
            wait: 'Wait',
        },
        walkArounds: {
            a1: 'A1',
            brokenGlass: 'Broken glass',
            bump: 'Bump',
            cleaning: 'Cleaning',
            other: 'Other',
            scratch: 'Scratch',
        },
    },
    statusTooltip: {
        duplicate: 'You cannot change {0} for a duplicate lead',
        invalid: 'You cannot change {0} for an invalid lead',
        lost: 'You cannot change {0} for a lost lead',

        inputs: {
            appointment: 'the appointment date',
            approbation: 'the approbation',
            approved: 'the approved field',
            available: 'the availability date',
            beBack: 'the be back date',
            csi: 'the CSI date',
            dealerTour: 'the dealer tour field',
            deliverable: 'the date when the vehicle will be @:lexicon.deliverable.singular',
            delivered: 'the @:lexicon.delivered.singular date',
            delivery: 'the @:lexicon.deliveryDate.singular',
            deposit: 'the deposit field',
            gas: 'the gas field',
            inspected: 'the inspected field',
            institution: 'the institution',
            longTerm: 'the long term field',
            phoneAppointment: 'the phone appointment date',
            prepared: 'the prepared field',
            presented: 'the visit date',
            qualification: 'the qualification',
            recorded: 'the reported date',
            refinanced: 'the Buy Out date',
            roadTest: 'the test drive date',
            sale: 'the @:lexicon.sale.singular date',
            saleByPhone: 'the @:lexicon.sale.singular by phone date',
            takeOver: 'the turn over date',
            twentyFourHour: 'the 24 hr field',
            verified: 'the @:lexicon.sale.singular verification',
            walkAround: 'the walk-around',
            waitingSale: 'the waiting @:lexicon.sale.singular',
            writeUp: 'the write-up field',
        },
    },
    vehicles: {
        accessories: 'Accessories',
        accidented_damage_cost: 'Accident $',
        accidentedTooltip: 'Indicates if the actual vehicle has accident',
        actual_value: 'Actual value',
        actualValueTooltip: 'Actual resale value',
        addNewVehicle: 'New vehicle',
        addNewVehicleInventory: 'From inventory',
        allowed_mileage: 'Allowed KM',
        allowedMileageYearly: 'km / yr',
        atv: 'ATV',
        auto: 'Automatic',
        automotive: 'Automotive',
        average: 'Average',
        balance: 'Balance',
        balanceTooltip: 'Remaining installments x Payment',
        baseWarranty: 'Base warranty',
        between_21_30_feet: 'Between 21 & 30 feet',
        between_31_40_feet: 'Between 31 & 40 feet',
        bike: 'Bike',
        bi_monthly: 'Semi-Monthly',
        biMonthly: 'Semi-Monthly',
        aux_deux_semaines: 'Bi-Weekly',
        biWeekly: 'Bi-Weekly',
        blower: 'Blower',
        boat: 'Boat',
        bodyStyle: 'Body style',
        bodyType: 'Body type',
        border_size: 'Border size',
        budget_max: 'Max. budget',
        budget_min: 'Min. budget',
        buyBack: 'Buy Out',
        calculator_value: 'Estimated',
        caravan: 'Caravan',
        cash: 'Cash',
        Cash: 'Cash',
        category: 'Category',
        categoryRV: 'Category RV',
        class_a_diesel: 'Class A Diesel',
        clean: 'Clean',
        color: 'Color',
        colorExterior: 'Exterior Color',
        colorInterior: 'Interior Color',
        colorExtInt: 'Ext • Int',
        condition: 'Condition',
        contractEnd: 'Contract end date',
        decodeVin: 'Decode VIN',
        description: 'Description',
        diesel: 'Diesel',
        division: 'Division',
        documentation: 'Documentation',
        drivingWheels: 'Drivetrain',
        electric: 'Electric',
        endWarrantyDate: 'End warranty',
        engine: 'Engine',
        equity: 'Equity',
        equityTooltip: 'Value - Balance - Residual',
        exteriorColor: 'Exterior color',
        extendedWarranty: 'Extended warranty',
        extra_clean: 'Extra clean',
        fifth_wheel: 'Fifth wheel',
        finance: 'Finance',
        financing: 'Financing',
        Financing: 'Financing',
        frequency: 'Frequency',
        essence: 'Gasoline',
        fuel: 'Fuel',
        gasoline: 'Gasoline',
        generator: 'Generator',
        hybrid: 'Hybrid',
        hybride: 'Hybrid',
        horsepower: 'Horse power',
        initialCash: 'Cashdown',
        inStock: 'In stock',
        intention: 'Intention',
        interiorColor: 'Interior color',
        in_service_date: 'In service Date',
        kmAllowance: 'KM Allowance',
        leaseTransfer: 'Lease transfer',
        leasing: 'Leasing',
        Leasing: 'Leasing',
        length: 'Length',
        link: 'Lien',
        location: 'Leasing',
        Loan: 'Loan',
        loan: 'Loan',
        make: 'Make',
        manual: 'Manual',
        mechanical: 'Mec. product',
        mileage: 'Odometer',
        mileageExcess: 'Est. mileage excess',
        mileageExcessTooltip: 'Estimated mileage excess at the end of the warranty',
        modality: 'Modality',
        modalityPaymentType: 'Payment Type',
        model: 'Model',
        modelCode: 'Model code',
        monthly: 'Monthly',
        Monthly: 'Monthly',
        months: 'months',
        monthsRemaining: 'Month remaining|Months remaining',
        paymentsRemaining: 'Payment remaining|Payments remaining',
        motoculteur: 'Rototiller',
        motorcycle: 'Motorcycle',
        motorized: 'Motorhome',
        motorized_a: 'Motorized A',
        motorized_b: 'Motorized B/B+',
        motorized_c: 'Motorized C',
        mower: 'Mower',
        msrp: 'MSRP',
        noEstimate: 'No Appraisal value',
        noInfo: 'This Vehicle of Interest does not have a Make, Model or Year saved',
        noStockNumber: 'No stock number',
        noTrim: 'No trim information',
        noWantedVehicle: 'This lead does not have a Vehicle of Interest',
        offer_number: 'Offer #',
        one_payment: 'One payment',
        onePayment: 'One payment',
        options: 'Options',
        order_number: 'Order #',
        outside: 'Outside',
        over_40_feet: '41 feet and over',
        owing: 'Owing',
        payment: 'Payment',
        paymentAmount: 'Payment Amount',
        paymentDetails: 'Payment Details',
        paymentFrequency: 'Payment Frequency',
        paymentType: 'Payment Type',
        paymentWithTax: 'Payment with tax',
        preparation: 'Preparation',
        price: 'Price',
        soldPrice: 'Sold Price',
        soldPriceTooltip: 'Initial price of the vehicle at time of sale.',
        priceAfterDiscount: 'Price After Discounts',
        profit: 'Profit',
        rate: 'Rate',
        refinance: 'Refinance',
        refuseToRenew: 'Refuse to @:lexicon.renewed.infinitive',
        renewal: '@.capitalize:lexicon.renewed.infinitive',
        requested: 'Requested',
        requestedValue: 'Consumer Ask',
        resaleValue: 'Resale value',
        residual: 'Residual',
        residualValue: 'Residual value',
        marketValue: 'Market Value',
        return: 'Return',
        rough: 'Rough',
        saved_date: 'Reported on',
        securityDeposit: 'Security deposit',
        sequential: 'Sequential',
        sleeping: 'Sleeping',
        snowmobile: 'Snowmobile',
        soldInDifferentLead: 'This stock is marked as sold in a different lead',
        stock: 'Stock',
        stockState: 'Stock state',
        stock_number: 'Stock #',
        subtotal: 'Subtotal',
        suffix: 'Suffix',
        suv: 'SUV',
        tent_trailer: 'Tent trailer',
        term: 'Term',
        tire_type: 'Tires',
        tires: 'Tires $',
        tireTooltip: 'Tires included at the time of @:lexicon.sale.singular',
        tireTypeTooltip: 'Tires included with the Trade-in Vehicle',
        torque: 'Torque',
        total: 'Total',
        totalAllowedMileage: 'Total KM allowance',
        totalPrice: 'Total price',
        tradeInDetails: 'Customer Submitted Trade-In Details',
        trade_notes: 'Notes',
        trade_type: 'Buying',
        tradeIn: 'Trade-In',
        tradeTypeDisabledTooltip: 'A value must be entered before selecting this option.',
        tradeTypeTooltip:
            'When selecting an option, the vehicle will be considered bought for statistical purposes.',
        trailer: 'Trailer',
        trailer_park: 'Trailer park',
        transmission: 'Transmission',
        travel_trailer: 'Travel trailer',
        trim: 'Trim',
        truck: 'Truck',
        Two_weeks: 'Bi-Weekly',
        under_20_feet: '20 feet and under',
        unverify: 'Remove verification',
        utility: 'Utility (side by side)',
        value: 'Value',
        valueTooltip: 'Purchase value',
        van: 'Van',
        vAutoValue: '$ vAuto',
        vehicle_state: 'Vehicle State',
        vehicleStatus: 'Vehicle Status',
        verify: 'Mark as verified',
        verifiedTooltip: 'Verified @:lexicon.sale.singular',
        version: '@.capitalize:lexicon.version.singular',
        vin: 'VIN',
        vinDecodingFailed:
            'Failed to decode VIN. Make sure the VIN is valid and has 17 characters.',
        warranty: 'Warranty',
        warranty_type: 'Warranty Type',
        water_pump: 'Water pump',
        watercraft: 'Watercraft',
        weekly: 'Weekly',
        Weekly: 'Weekly',
        weight: 'Weight',
        year: 'Year',
        year_max: 'Max. year',
        year_min: 'Min. year',
        estimated: 'Appraised',
        estimatedBy: 'Estimated by',
        received: 'Evaluation done by {0} on {1}',
        openStock: 'Choose a vehicle in stock',
        openStockCondition: 'A selected make is required to choose a vehicle in stock',
        stockTitle: 'Vehicle Inventory',
        noStockFoundForFilter: 'No vehicle found for {0} {1} {2}.',
        noStockFoundForFilterWithStock: 'No vehicle found for {0} {1} {2} with stock {3}.',
        noStockFoundForFilterOnlyStock: 'No vehicle found for stock {0}.',
        emptyInventory: 'No vehicle available in inventory.',
        searchingVehicles: 'Searching for vehicles...',
        trimMissing: 'No trim information',
        stockMissing: 'No stock number provided',
        transmissionMissing: 'No transmission information',
        drivetrainMissing: 'No drivetrain information',
        drivetrainTransmissionMissing: 'No drivetrain information',
        mileageMissing: 'No mileage information',
        unavailable: 'Unavailable',
        order: 'Order',
        locate: 'Locate',
        pending: 'Pending',
        building: 'Building',
        transport: 'In transit',
        arrived: 'Arrived',
        stockTBD: 'Stock to be determined',
        stockStatusTBD: 'Status to be determined',
        new: 'New',
        used: 'Used',
        certified: 'Certified',
        demo: 'Demo',
        invoice: 'Invoiced',
        production: 'In production',
        transit: 'In transit',
        hold: 'On hold',
        sold: 'Sold',
        noInventoryUnit: 'This vehicle is not from inventory',
        noStockOrMakeModelYear:
            'This vehicle does not have a stock number or a make,, model and a year',
        noInventoryUnitFromSupplier: 'This vehicle is not from {0} inventory',
        noMakeModelYear: 'This vehicle is missing a make, model or a year',
        noVin: 'This vehicle is missing a VIN',
        none: 'None',
        unknown: 'Unknown',
        excellent: 'Excellent',

        tireType: {
            all: 'All',
            null: '-',
            summer: 'Summer',
            winter: 'Winter',
        },
        tradeTypes: {
            excluded: 'Excluded',
            lost: 'Lost',
            none: 'None',
            other: 'Other',
            recycled: 'Recycled',
            retail: 'Retail',
            return: 'Return',
            wholesale: 'Wholesale',
        },
        vinMissingDataModal: {
            title: 'Data to validate',
        },
    },
    unsubscribeModal: {
        call: 'This will re-enable calls for this lead.',
        email: 'This will re-enable emails for this lead.',
        sms: 'This will re-enable SMS for this lead.',
    },
    export: {
        noVehicleOption: 'Do not export this type of vehicle',
        noVehicleOptionEligible: 'No eligible vehicles',
        lender: 'Lender',
        noneConfigured: 'No lenders configured. Please contact Activix Support for assistance',
        purchase: 'Purchase',
        lease: 'Lease',
        deal: 'Deal',
        quote: 'Quote',
        financeType: 'Financing type',
        dealType: 'Deal type',
        personal: 'Personal',
        business: 'Business',
        dealerTrade: 'Dealer Trade',
        wholesale: 'Wholesale',
        fleet: 'Fleet',
        internalTransfer: 'Internal Transfer',
        refinancing: 'Refinancing',
        PreOrder: 'Pre-order',
        booked: 'Booked',
        confirmed: 'Confirmed',
        loan: 'Loan',
        cash: 'Cash',
        balloon: 'Balloon',
        dealStatus: 'Status',
        frequencyType: {
            oneTime: 'One time',
            monthly: 'Monthly',
            weekly: 'Weekly',
            biWkeely: 'Bi-weeky',
            yearly: 'Yearly',
        },
        wantedVehicleToExport: 'Vehicle of Interest to export',
        exchangeVehicleToExport: 'Trade-in Vehicle to export',
        noCdkInventoryUnit: 'Vehicle not from CDK inventory',
        noInventoryUnit: 'Vehicle not from {0} inventory',
    },
    blocked: {
        hasAlreadyASoldVehicle: 'This lead already has a @:lexicon.sold.singular vehicle',
        isPolestarLead:
            'Polestar does not allow this action through the CRM. Please use the retail portal.',
        leadAlreadyHasAppointment: 'This lead already has an appointment',
        leadAlreadyPresented: 'This lead already has a visit',
        leadHasDelivery: 'This lead has a planned @:lexicon.delivery.singular',
        leadIsBeBack: 'This lead is a be-back',
        leadIsDelivered: 'This lead is @:lexicon.delivered.singular',
        leadIsRefinanced: 'This lead is a Buy Out',
        leadIsRenewed: 'This lead is @:lexicon.renewed.singular',
        leadIsServiceWithConfirmation:
            'This lead is from the Service division and has a confirmed appointment',
        leadIsService: 'This is a Service lead',
        leadIsSold: 'This lead is @:lexicon.sold.singular',
        leadIsWalkIn: 'This lead is @:lexicon.walkIn.prefix',
        leadMustBeDelivered: 'The lead must be @:lexicon.delivered.singular',
        leadMustBeInvoiced: 'The lead must be invoiced',
        leadMustBeSold: 'The lead must be @:lexicon.sold.singular',
        leadMustBeRenewed: 'The lead must be @:lexicon.renewed.singular',
        leadNeedVisit: 'A visit is required',
        leadNeedDivision: 'A division is required',

        needRenewedWantedVehicle:
            'The lead must have a @:lexicon.renewed.singular Vehicle of Interest',
        needSoldWantedVehicle: 'The lead must have a @:lexicon.sold.singular Vehicle of Interest',
        needToBeDirector: 'You must be a manager to edit this field',
        needVehicleInfoAndStock:
            'You must fill the make, model and stock fields to modify this field',
        needVehicleInfo: 'You must fill the make and model fields to modify this field',

        specificCreatedMethod: 'This field is not editable when the lead comes from "{0}"',
        readOnlyField: 'This field is not editable',
        tradeReport: 'You need the "Acquisitions Report" module',
        unauthorizedFieldUpdate: 'You do not have access to update this field',
        unauthorizedLeadUpdate: 'You do not have access to update this lead',
        vehicleAppraisalCompleted: 'The vehicle appraisal has been completed',
        vehicleExported: 'The vehicle has been exported',
        isAppraisedByTrs: 'The vehicle has been appraised by AutoTrader',
        vehicleMustBeLeased: 'The vehicle must be leased',
        vehicleStock: 'The vehicle is linked to an inventory unit',

        leadStatus: {
            duplicate: 'This field is not editable on a duplicate lead',
            invalid: 'This field is not editable on an invalid lead',
            lost: 'This field is not editable on a lost lead',
        },

        userAssignation: {
            cannotModifyAlreadyAssignedUser: 'You cannot modify an already assigned user',
            reassignationInProgress: 'A user reassignation is in progress',
            selfAssignementForbidden: 'You cannot manually assign yourself',
        },

        attribution: {
            disabledByDeliveredRule:
                'You cannot add leads to a @:lexicon.delivered.singular sales journey',
            disabledByLeadStatusRule: 'You cannot add leads to a {status} sales journey',
        },
    },
    quote: {
        calculatePricing: 'Calculate pricing',
        calculatedPrice: 'Calculated price',
        priceResponse: 'The pricing response will be displayed here...',
        success: 'Quote successfully saved',
        getBillOfSale: 'Get bill of sale',
        billOfSale: 'Bill of sale',
        billOfSaleProductId: 'Bill of sale product id',
        billOfSaleResponse: 'The bill of sale response will be displayed here...',
    },
    capitalizedOptions: {
        title: 'Capitalized Options',
        optionsCount: '({count} option) | ({count} options)',
    },
    nonCapitalizedOptions: {
        title: 'Non-Capitalized Options ',
        optionsCount: '({count} option) | ({count} options)',
    },
    select: {
        all: 'All',
        noOption: 'No options.',
        noResults: 'No result.',
        selected: 'selected',
    },
};
